import { useConnect } from '@zealforchange/redux-encapsulation'
import { State } from '@reducers/modules/headerGoods'
import * as actions from '@actions/headerGoods'

export function useGoodsStyleDispatch() {
  return useConnect<{ HeaderGoodsReducer: State }, { HeaderGoodsReducer: State }, typeof actions>((state: { HeaderGoodsReducer: State }) => {
    return { HeaderGoodsReducer: state.HeaderGoodsReducer }
  }, actions) as [{ HeaderGoodsReducer: State }, typeof actions]
}
